<label *ngIf="label" [attr.for]="id">{{ label }}<itm-required *ngIf="validators?.required">*</itm-required></label>
<select [attr.id]="id" class="form-control {{ cssClass }}" [disabled]="disabled"
	(input)="myOnChange($event.target.value)" (change)="myOnChange($event.target.value)" (blur)="onTouched()" #controlRef>
	<option *ngIf="placeholder" value="">{{ placeholder }}</option>
	<option *ngFor="let i of list" value="{{ i.value }}" [attr.selected]="i.value == val ? 'selected' : null">
		{{ i.descr }}
	</option>
</select>
<small *ngIf="showValidationMessage()" class="text-danger">
	<ng-content></ng-content>
</small>